import { FavoriteMutations } from '@sales-app/graphql/mutations/favorite.mutations'
import { PinnedHomesMutations } from '@sales-app/graphql/mutations/pinnedHomes.mutations'

import { useAlertContext } from '@/context'
import { useGraphqlMutation } from '@/hooks/useGraphql'

import { useFavoritesPinnedHomes } from '../useFavoritesPinnedHomes/useFavoritesPinnedHomes'

export function useRecommendedHomesMutations() {
  const { refetch } = useFavoritesPinnedHomes()
  const { setAlert } = useAlertContext()
  const { mutate: mutateCreatePin, isPending: isCreatePinLoading } = useGraphqlMutation(
    PinnedHomesMutations.createPinnedHome(),
    {
      onSuccess: () => {
        setAlert('Home pinned successfully', 'success')
        refetch()
      },
    },
  )

  const { mutate: mutateCreateFavorite, isPending: isCreateFavoriteLoading } = useGraphqlMutation(
    FavoriteMutations.createFavorite(),
    {
      onSuccess: () => {
        setAlert('Home favorited successfully', 'success')
        refetch()
      },
    },
  )

  const { mutate: mutateRemoveFavorite, isPending: isRemoveFavoriteLoading } = useGraphqlMutation(
    FavoriteMutations.deleteFavorite(),
    {
      onSuccess: () => {
        setAlert('Favorite removed successfully', 'success')
        refetch()
      },
    },
  )

  const { mutate: mutateRemovePin, isPending: isRemovePinLoading } = useGraphqlMutation(
    PinnedHomesMutations.removePinnedHome(),
    {
      onSuccess: () => {
        setAlert('Home unpinned successfully', 'success')
        refetch()
      },
    },
  )
  const isMutationLoading =
    isCreateFavoriteLoading || isCreatePinLoading || isRemoveFavoriteLoading || isRemovePinLoading

  return {
    isMutationLoading,
    mutateRemovePin,
    mutateRemoveFavorite,
    mutateCreateFavorite,
    mutateCreatePin,
  }
}
